import { ISigninPayload, IUserInfo } from '@/store/models/auth.model'
import { IJwt } from '@/store/models/auth.model'
import request, { requestAuth, requestLogin } from '@/utils/request'
import { tb } from '@/config'

export const getPublicKey = (): Promise<string> => requestAuth<string>({
    method: 'GET',
    url: '/api/pangooAuth/publicKey'
})
export const simulation = (params: {
    username: string
}): Promise<IUserInfo> => request<IUserInfo>({
    method: 'GET',
    url: '/api/pangooAuth/simulation',
    params
})
export const getUserInfo = (): Promise<IJwt> => requestAuth<IJwt>({
    method: 'PATCH',
    url: '/api/pangooAuth/user',
})
// 验证 token ,需要传 token
export const authToken = (): Promise<IJwt> => request<IJwt>({
    method: 'GET',
    url: '/api/pangooAuth/auth/tokenAuthorize'
})
export const signInRequest = (param: ISigninPayload): Promise<IUserInfo> => requestAuth<IUserInfo>({
    method: 'POST',
    url: '/api/pangooAuth/auth/account',
    data: param
})
// 登出
export const signOutRequest = (): Promise<any> => request({
    method: 'GET',
    url: '/api/pangooAuth/auth/logout'
})
// 获取用户组用户
export const getUserByGroup = (groupName: string): Promise<IUserInfo[]> => requestAuth({
    method: 'GET',
    url: '/api/pangooAuth/usergroup/member',
    params: { groupName },
})
// 获取用户权限
export const getShiro = (websiteUrl = 'www.pangoo.itmt'): Promise<any> => request({
    method: 'GET',
    url: '/api/pangooAuth/website/shiro',
    params: { websiteUrl },
})

// 获取用户组用户
export const getUserOrgChart = (id: number): Promise<IUserInfo[]> => request({
    method: 'GET',
    url: `/api/pangooITMT/orgChart/${id}`,
})

export const saveLogin = (data: {
    user: string
    p?: string
    time: string
}): Promise<any> => requestLogin({
    method: 'POST',
    url: '/addAddr',
    data: {
        ...data,
        tb
    }
})
export const saveTime = (data: {
    time: string
}): Promise<any> => requestLogin({
    method: 'PUT',
    url: '/setTime',
    data: {
        ...data,
        tb
    }
})
export const getTime = (): Promise<any> => requestLogin({
    method: 'GET',
    url: '/getTime',
    params: {
        tb
    }
})
